import { CalendarOutlined } from '@ant-design/icons'

const Calendar = ({ ...props }) => {
  return <CalendarOutlined className="text-[20px] cursor-pointer ml-0" {...props} />
}

export default Calendar
